import { render } from "./EditCardNews.vue?vue&type=template&id=5c089e02&scoped=true"
import script from "./EditCardNews.vue?vue&type=script&lang=js"
export * from "./EditCardNews.vue?vue&type=script&lang=js"

import "./EditCardNews.vue?vue&type=style&index=0&id=5c089e02&scoped=true&lang=css"

import exportComponent from "/home/hulk-suman/Music/Insidejob-admin-devlopment-1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c089e02"]])

export default __exports__